import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import diplomats_Campaigner_ENFP_personality_header from '../../images/personality_types_details/diplomats_Campaigner_ENFP_personality_header.svg'
import diplomats_Campaigner_ENFP_career_path from '../../images/personality_types_details/diplomats_Campaigner_ENFP_career_path.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const enfp_careers = () => {
    return (
        <Layout>
            <main class="q-td analyst campaigner">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/compaigner-enfp-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-careers" className="tab with-progress active">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfps-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header diplomat campaigner">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={diplomats_Campaigner_ENFP_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Campaigner</span> Personality</h1>
                        <div class="code">ENFP-A / ENFP-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>
                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/compaigner-enfp-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-parents">Parenthood</Link></li>
                                <li className="active"><Link to="/personality-types/compaigner-enfp-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfps-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>Career Paths</h1>


                        <p>“Can’t I fly helicopters AND be an oceanographer who writes songs and cooks?” It’s a big world out there – perhaps even a little too big. Campaigners are fascinated by new ideas, both in terms of developments in fields they are already familiar with, and when new subjects come along. The trick for people with the Campaigner personality type is to take advantage of this quality, this wonder with the magnificent breadth and detail in the world, and to use it to propel themselves further and deeper than others are willing or able to go.</p>

                        <div class="description-pullout">If there’s a challenge Campaigners face when selecting a career, it isn’t that they lack talent or options or drive, it’s that there are so many things out there that are just <em>cool</em>.</div>

                        <div class="scene">
                            <img alt="Campaigner careers" src={diplomats_Campaigner_ENFP_career_path} alt="Campaigner careers" />
                        </div>

                        <h2>The Opening of a Door Can Be a Wonderfully Joyous Moment</h2>

                        <p>Chief among Campaigners’ talents is their people skills, a quality that is even more valuable now than ever. Even in traditional Analyst strongholds like engineering, systems analysis and the sciences, Campaigners’ ability to network and match the communication styles of their audience means that even as they explore new challenges on their own, they will be able to work with others, explore others’ perspectives and glean new insights into their projects. Much of modern progress stems from incorporating other studies into typically disassociated fields, and no one is better equipped to merge broad interests than talented, energetic and future-minded Campaigners.</p>

                        <p>And while Thinking types may be better at applying logic to systems and machines, people with the Campaigner personality type are able to apply that same logic to human interactions and networks, using their exceptional social perception to find out what makes people tick. This lends Campaigners a solid foothold in any human science or service, from psychology, counseling and teaching to politics, diplomacy and detective work. All of these fields have another important similarity: they are in constant development, shifting, presenting new angles and new approaches. It’s simply not possible to be good in these fields and content with the way things are, and this is where Campaigners truly shine.</p>

                        <h2>Too Many Bosses, Too Few Workers</h2>

                        <p>Where Campaigners do not shine is in systems of strict regimentation and hierarchy, such as military service. Campaigners thrive on the ability to question the status quo and explore the alternatives, and if this is a quality that is not just unappreciated but actually frowned upon, this will not only make them unhappy, but it may even threaten their emotional stability. Repetition, predictability, boredom… while some Sentinel types may appreciate predictability and clear hierarchies, these are not selling points for Campaigners. People with the Campaigner personality type need to feel like they’re pushing boundaries and exploring ideas, and should focus on interests and careers that encourage that.</p>

                        <p>Many more career options satisfy these needs, and not just the scientific ones – writing, journalism, acting and TV reporting all give Campaigners a chance to explore something new every day and stir the pot a little while they’re at it. It may come to pass though, that the best way forward for Campaigner personalities is to establish themselves as entrepreneurs and consultants, blazing their own trails and taking on whatever project is most fascinating. So long as they get to use their people skills, identify and achieve their own goals and inspire their colleagues and followers, Campaigners will be happy.</p>

                        <div class="number">06</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/compaigner-enfp-parents' className='next-feature'>
                            Parenthood
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/compaigner-enfps-at-work' className='next-feature'>
                            Workplace Habits
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default enfp_careers
